<script setup>
import { inject } from 'vue';

const trans = inject('trans');

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  logo: {
    type: String,
    default: null,
  },
  link: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <div class="manual-wrapper">
    <div class="manual-box">
      <div v-if="logo !== null" class="manual-logo-wrapper">
        <div class="manual-logo-image">
          <img :alt="`logo-${name}`" :src="logo" />
        </div>
      </div>
      <div class="manual-application-name">
        {{ name }}
      </div>
      <div class="manual-more-info">
        <inertia-link :href="link" class="button button_hollow">
          {{ trans('dashboard.more_info') }}
        </inertia-link>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.manual {
  &-wrapper {
    display: block;
    height: 100%;
  }

  &-box {
    width: 12rem;
    height: 18rem;
    border-radius: 0.9rem;
    filter: drop-shadow(2px 2px 2.5px rgba(0, 122, 255, 0.09));
    background: white;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 20px;
    padding-bottom: 20px;
  }

  &-logo {
    &-wrapper {
      display: flex;
      justify-content: center;
      margin-top: 2rem;
    }

    &-image {
      width: 120px;
      height: 100px;
    }
  }

  &-application-name {
    display: flex;
    justify-content: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 14px;
    font-style: normal;
    text-align: left;
    color: #0098e7;
    margin-top: 2rem;
  }

  &-applications {
    font-size: 14px;
    font-weight: 300;
    line-height: 14px;
    font-style: normal;
    text-align: center;
    color: #5c5d5d;
    margin-top: 1rem;
    cursor: help;
  }

  &-more-info {
    display: flex;
    justify-content: center;
    margin-top: 1rem;
    position: relative;
  }
}
</style>
